import { NgFor, NgSwitch, NgSwitchCase, NgSwitchDefault, NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { TeamShootout } from '@frontend/sports/betting-offer/feature/model';

@Component({
    selector: 'ms-penalty-shootout',
    templateUrl: 'penalty-shootout.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [NgFor, NgTemplateOutlet, NgSwitch, NgSwitchDefault, NgSwitchCase],
})
export class PenaltyShootoutComponent {
    @Input() penalties: TeamShootout;
}
